export const DEFAULT_PROFILE_IMAGE_URL = '/images/default-profile.png';
